export const removeBase64Metadata = (dataUrl: string) =>
  dataUrl.replace(/^data:image\/\w+\+?\w+;base64,/, '');
